import type { AxiosRequestHeaders, AxiosResponse } from "axios";

export function openDownloaded(response: AxiosResponse<Blob>): void {
  const headers = response.headers as AxiosRequestHeaders;
  const filename = parseContentDispositionHeaderFilename(
    headers.get("Content-Disposition") as string,
  );
  _openDownload(filename, response.data);
}

function parseContentDispositionHeaderFilename(headerValue: string): string {
  let filename;
  if (headerValue !== "" && headerValue.includes("attachment")) {
    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
    const matches = filenameRegex.exec(headerValue);
    filename = matches?.[1].replace(/['"]/g, "");
  }
  return filename ?? "download.bin";
}

function _openDownload(filename: string, blob: Blob): void {
  // @ts-expect-error: IE specific
  if (window.navigator.msSaveBlob !== undefined) {
    /*
     * IE workaround for "HTML7007: One or more blob URLs were revoked by
     *  closing the blob for which they were created. These URLs will no longer
     *  resolve as the data backing the URL has been freed."
     */
    // @ts-expect-error: IE specific
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call -- IE specifics
    window.navigator.msSaveBlob(blob, filename);
  } else {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- Firefox / Chrome specifics
    const URL = window.URL ?? window.webkitURL;
    const downloadUrl = URL.createObjectURL(blob);
    if (filename !== "") {
      // use HTML5 a[download] attribute to specify filename
      const a = document.createElement("a");
      // safari doesn't support this yet
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- Safari specifics
      if (a.download === undefined) {
        window.location.href = downloadUrl;
      } else {
        a.href = downloadUrl;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
      }
    } else {
      window.location.href = downloadUrl;
    }
    // Cleanup:
    setTimeout(function () {
      URL.revokeObjectURL(downloadUrl);
    }, 100);
  }
}
